import React from 'react';

import Loader from '@vlabs/shared/legacy-components/loader/Loader';

import st from './ChartPanel.module.sass';
import useChart from './useChart';

function ChartPanel({ chartData, chartType }) {
  const Chart = useChart(chartData, chartType);

  return (
    <React.Fragment>
      {!chartData && (
        <div className={st.Loader}>
          <Loader />
        </div>
      )}
      {!!chartData && (
        <div className={st.Chart}>
          {Chart}
        </div>
      )}
    </React.Fragment>
  );
}

export default ChartPanel;
